import { Helmet } from "react-helmet-async"
import { Container } from "@sembark-travel/ui-base"
import { InvoiceTemplates } from "../../../../../EmailPdfTemplates"

export default function OrganizationInvoiceTemplatesPage() {
	return (
		<>
			<Helmet>
				<title>Invoice PDF/Email Templates</title>
			</Helmet>
			<Container paddingY="4">
				<InvoiceTemplates />
			</Container>
		</>
	)
}
